import { Injectable } from '@angular/core';
import { DwAction, DwActionResult, DwActionType, DwMdFormActionHandler, DwMdFormActionState } from '@devwareapps/devware-cap';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppMetaDataItemNames, CourseEntity } from '../../../meta-data/app-meta-data.service';
import { AppPermissions } from '../../../meta-data/app-permissions.enum';
import { CourseRepositoryService } from '../services/course-repository.service';

@DwAction({
  keyName: 'course-assign-all-schools',
  display: 'Course - Assign to All Schools',
  actionType: DwActionType.formAction,
  parentItemName: AppMetaDataItemNames.Course,
  isGlobal: false,
  defaultButtonConfig: {
    useParentDisplay: false,
    buttonText: 'Assign to All Schools',
    iconClass: 'fa fa-school',
    buttonClass: 'btn btn-secondary',
    buttonTitle: 'Assigns this course to every active flight school'
  },
  defaultSecurityConfig: {
    requireAuthentication: true,
    useEmulatedPermissions: true,
    permissionMeaning: AppPermissions.contentAdmin,
    requireCanUpdate: true
  },
  defaultConfirmConfig: {
    showDialogConfig: true,
    showConfirmDialog: true,
    title: 'Assign to All Schools',
    message: 'Assign this course to every active flight school? Existing assignments will not be changed.'
  }
})
@Injectable()
export class CourseAssignAllSchoolsActionService implements DwMdFormActionHandler {
  constructor(private courseRepositoryService: CourseRepositoryService) {}

  handleAction(actionState: DwMdFormActionState): Observable<DwActionResult> {
    const course = actionState.formApi.getFormData<CourseEntity>();

    if (!course.CourseId) {
      return of({ success: false, cancelled: true });
    }

    return this.courseRepositoryService.assignCourseToAllSchools(course.CourseId)
      .pipe(map(assignedCount => ({
        success: true,
        message: assignedCount
          ? `Course assigned to ${assignedCount} additional school${assignedCount === 1 ? '' : 's'}.`
          : 'Course is already assigned to every active school.'
      })));
  }
}
